import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import {
  AppSurfaceStore,
  AuthStore,
  SessionKindEnum,
} from '@marineform/manage-data-access';

/**
 * Lets an operator through. Sends everyone else to their session home path.
 */
export const manageAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const appSurfaceStore = inject(AppSurfaceStore);

  if (authStore.sessionKind() === SessionKindEnum.OPERATOR) {
    return true;
  }

  return router.createUrlTree([appSurfaceStore.homePath()]);
};
